import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
/* import Divider from './Divider' */
import GenAIFilterSelectModal from "./GenAIFilterSelectModal";
import { prdtNavButton, productNavButtonBlack, gen_ai_prdtNavButton } from "../../assets";
import "./GenAIFilterComponent.css";
import GenAIFilterHistogram from "./GenAIFilterHistogram";
import "./GenAIFilterHistogram.css";

export default function GenAIFilterMenu(props) {
  const {
    appliedFilters,
    filters,
    //fullDocRange,
    //handleOpenProductSelection,
    handleChangeFilterCategory,
    // handleClearFilters,
    filterCategory,
    isOpen,
    handleApply,
    handleCloseFilterSelect,
    handleSelectFilter,
    handleToggleFilter,
    openFilters,
    selectedFilters,
    selectedParentFilterArr,
    selectedParent,
    handleResetFilters,
    customWidth,
    recentlyUsedFilters,
    renderedFiltered,
    // handleYearSelection,
    //metadata,
    // gotoPage,
    //sourceType,
    // years,
    // yearSelection,
    popupActive,
    appliedFiltersForOnlyiMS,
    filterYears,
    fromYear,
    toYear,
    handleYearSelection,
    handlePageChange,
    fromRecentlyAddedUpdated,
    toRecentlyAddedUpdated,
    gotoPageRecentlyAddedUpdated,
    isError,
    isHomePageFilter,
  } = props;

  const [yearSelection, setYearSelection] = useState({ min: 0, max: 0 });
  useEffect(() => {
    let tempYearSelection = {
      min: fromYear ? fromYear : 0,
      max: toYear ? toYear : 0,
    };
    setYearSelection(tempYearSelection);
    //}, [])
  }, [fromYear, toYear]);

  /**
   * Handle the click event of the product selection link
   *
   * @param  {Object} event
   * @param  {String} key
   */
  /* const openProductSelection = () => {
    handleOpenProductSelection()
  } */

  /**
   * Handle the click event of one of the filter categories links.
   *
   * @param  {Object} event
   * @param  {String} key
   */
  const changeFilterCategory = (event, key) => {
    event.preventDefault();
    handleChangeFilterCategory(key);
  };

  /**
   * Handle the click event of the clear-filters button.
   *
   * @param  {Object} event
   */
  // const clearFilters = (event) => {
  //   event.preventDefault();
  //   handleClearFilters();
  // };

  /**
   * Conditionally render the clear-all-filters button as necessary.
   *
   * @return {Object|null}
   */
  // const renderClearAllAppliedFilters = () => {
  //   return (
  //     <button
  //       className="gen-ai-filter-popup-button clickable"
  //       disabled={appliedFilters.length < 1}
  //       onClick={clearFilters}
  //     >
  //       <div className="gen-ai-filter-popup-button-text">Clear All Filters</div>
  //     </button>
  //   );
  // };
  const renderOnlyiMSFilter = () => {
    return appliedFiltersForOnlyiMS.map((filter) => {
      let replaceFilter = `${filter}`.replace(
        "Recently Added_Updated",
        "Recently Added/Updated"
      );
      return (
        <div class="ignored-gen-ai-filter-wrapper">
          <span class="ignored-text">{replaceFilter}</span>
        </div>
      );
    });
  };

  /* const renderProductFilter = () => {
    return (
      <div className='gen-ai-filter-item clickable'
           onClick={openProductSelection}>
        <div className='gen-ai-filter-text'>
          Products
        </div>
        <FontAwesomeIcon className='gen-ai-filter-chevron' icon="chevron-right" fixedWidth color='#979797' />
      </div>
    )
  } */
  const handleYear = (newYears) => {
    setYearSelection(newYears);
    handleYearSelection(newYears);
  };

  const gotoPage = (pageNumber) => {
    setTimeout(() => {
      handlePageChange(pageNumber);
    }, 500);
  };

  const renderFilterHistogram = () => {
    if (filterYears.length > 0 && toYear && fromYear && !isError) {
      let maxYear =
        filterYears[filterYears.length - 1].key > toYear
          ? filterYears[filterYears.length - 1].key
          : toYear;
      let minYear =
        filterYears[0].key < fromYear ? filterYears[0].key : fromYear;
      let fullDocRange = { maxYear: maxYear, minYear: minYear };
      return (
        <GenAIFilterHistogram
          customWidth={customWidth}
          fullDocRange={fullDocRange}
          years={filterYears}
          yearSelection={yearSelection}
          handleYearSelection={handleYear}
          gotoPage={gotoPage}
        />
      );
    } else {
      return <></>;
    }
  };
  let filterYearDocCount = filterYears
    .map((x) => x.doc_count)
    .reduce((partialSum, a) => partialSum + a, 0);
  const orderedFilters = Object.values(filters).sort((a, b) => {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  });

  return (
    <>
      {orderedFilters.length > 0 ? (
        <>
          {/* <Divider /> */}
          {customWidth < 1000 ? (
            <>
              {customWidth < 600 ? (
                <div className="gen-ai-filter-container-mobile contained">
                  {!isOpen && (
                    <div style={{ width: "100%" }}>
                      {(window.location.pathname === "/pubMedResults" /*||
                        window.location.pathname === "/PubMedSearch"*/) &&
                        renderFilterHistogram()}
                      {orderedFilters.map((filter) => {
                        if (
                          filter.label === "Recently Added_Updated" &&
                          (window.location.pathname === "/viewReadingList" ||
                            window.location.pathname === "/old_viewReadingList" ||
                            window.location.pathname === "/rawvalues" ||
                            window.location.pathname === "/viewPubMedReadingList" ||
                            window.location.pathname === "/GenAIViewReadingList" ||
                            window.location.pathname === "/genAIAnswering" ||
                            (window.location.pathname && window.location.pathname.startsWith('/genAISearch')))
                        ) {
                          return "";
                        }
                        return (
                          <div
                            className={
                              selectedParent === filter.label
                                ? "select-gen-ai-filter-item gen-ai-filter-item clickable"
                                : selectedParentFilterArr.includes(filter.label)
                                  ? "gen-ai-filter-text-selected gen-ai-filter-item clickable"
                                  : "gen-ai-filter-item clickable"
                            }
                            key={filter.key}
                            onClick={(e) => changeFilterCategory(e, filter.key)}
                            title={
                              filter.key === "Recently Added_Updated"
                                ? "Recently Added/Updated"
                                : filter.key
                            }
                          >
                            <div className="gen-ai-filter-text">
                              {filter.label === "Recently Added_Updated" ? (
                                <>Recently Added/Updated</>
                              ) : filter.label === "Document Subtypes" ? (
                                <>
                                  {filter.label}
                                  <br />
                                  <span style={{ fontSize: "11px" }}>
                                    (Submission-Related Documents Only)
                                  </span>
                                </>
                              ) : (
                                <>{filter.label}</>
                              )}
                            </div>
                            {selectedParent === filter.label ? (
                              <div className="gen-ai-filter-expand-icon-wrapper">
                                <img src={prdtNavButton} alt="" />
                              </div>
                            ) : selectedParentFilterArr.includes(
                              filter.label
                            ) ? (
                              <div className="gen-ai-filter-expand-icon-wrapper">
                                <img src={productNavButtonBlack} alt="" />
                              </div>
                            ) : (
                              <div className="gen-ai-filter-expand-icon-wrapper">
                                <img src={prdtNavButton} alt="" />
                              </div>
                            )}
                          </div>
                        );
                      })}
                      {appliedFiltersForOnlyiMS &&
                        appliedFiltersForOnlyiMS.length > 0 &&
                        (window.location.pathname === "/pubMedResults" ||
                          window.location.pathname === "/PubMedSearch") && (
                          <div className="gen-ai-filter-only-ims-filters-wrapper">
                            <div className="ignored-ims-gen-ai-filter-wrapper">
                              <span class="ignored-header-text">
                                Missing Filters (iMS only)
                              </span>
                              <div className="gen-ai-filter-text">
                                {renderOnlyiMSFilter()}
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  )}
                  <div style={{ width: "100%" }}>
                    {popupActive ? null : (
                      <GenAIFilterSelectModal
                        appliedFilters={appliedFilters}
                        filterCategory={filterCategory}
                        filters={filters}
                        handleApply={handleApply}
                        handleCloseFilterSelect={handleCloseFilterSelect}
                        handleSelectFilter={handleSelectFilter}
                        handleToggleFilter={handleToggleFilter}
                        isOpen={isOpen}
                        openFilters={openFilters}
                        selectedFilters={selectedFilters}
                        handleResetFilters={handleResetFilters}
                        customWidth={customWidth}
                        recentlyUsedFilters={recentlyUsedFilters}
                        fromRecentlyAddedUpdated={fromRecentlyAddedUpdated}
                        toRecentlyAddedUpdated={toRecentlyAddedUpdated}
                        gotoPageRecentlyAddedUpdated={
                          gotoPageRecentlyAddedUpdated
                        }
                        renderedFiltered={renderedFiltered}
                        isHomePageFilter={isHomePageFilter}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div className="gen-ai-filter-container-tablet scrollable contained">
                  <div
                    style={{ width: "50%", height: "450px", overflowY: "auto" }}
                  >
                    {(window.location.pathname === "/pubMedResults" /*||
                      window.location.pathname === "/PubMedSearch"*/) &&
                      renderFilterHistogram()}
                    {orderedFilters.map((filter) => {
                      if (
                        filter.label === "Recently Added_Updated" &&
                        (window.location.pathname === "/viewReadingList" ||
                          window.location.pathname === "/old_viewReadingList" ||
                          window.location.pathname === "/rawvalues" ||
                          window.location.pathname === "/viewPubMedReadingList" ||
                          window.location.pathname === "/GenAIViewReadingList" ||
                          window.location.pathname === "/genAIAnswering" ||
                          (window.location.pathname && 
                        window.location.pathname.startsWith("/genAISearch")))
                      ) {
                        return "";
                      }
                      return (
                        <div
                          className={
                            selectedParent === filter.label
                              ? "select-gen-ai-filter-item gen-ai-filter-item clickable"
                              : selectedParentFilterArr.includes(filter.label)
                                ? "gen-ai-filter-text-selected gen-ai-filter-item clickable"
                                : "gen-ai-filter-item clickable"
                          }
                          key={filter.key}
                          onClick={(e) => changeFilterCategory(e, filter.key)}
                          title={
                            filter.key === "Recently Added_Updated"
                              ? "Recently Added/Updated"
                              : filter.key
                          }
                        >
                          <div className="gen-ai-filter-text">
                            {filter.label === "Recently Added_Updated" ? (
                              <>Recently Added/Updated</>
                            ) : filter.label === "Document Subtypes" ? (
                              <>
                                {filter.label}
                                <br />
                                <span style={{ fontSize: "11px" }}>
                                  (Submission-Related Documents Only)
                                </span>
                              </>
                            ) : (
                              <>{filter.label}</>
                            )}
                          </div>

                          {selectedParent === filter.label ? (
                            <div className="gen-ai-filter-expand-icon-wrapper">
                              <img src={prdtNavButton} alt="" />
                            </div>
                          ) : selectedParentFilterArr.includes(filter.label) ? (
                            <div className="gen-ai-filter-expand-icon-wrapper">
                              <img src={productNavButtonBlack} alt="" />
                            </div>
                          ) : (
                            <div className="gen-ai-filter-expand-icon-wrapper">
                              <img src={prdtNavButton} alt="" />
                            </div>
                          )}
                        </div>
                      );
                    })}
                    {appliedFiltersForOnlyiMS &&
                      appliedFiltersForOnlyiMS.length > 0 &&
                      (window.location.pathname === "/pubMedResults" ||
                        window.location.pathname === "/PubMedSearch") && (
                        <div className="gen-ai-filter-only-ims-filters-wrapper">
                          <div className="ignored-ims-gen-ai-filter-wrapper">
                            <span class="ignored-header-text">
                              Missing Filters (iMS only)
                            </span>
                            <div className="gen-ai-filter-text">
                              {renderOnlyiMSFilter()}
                            </div>
                          </div>
                        </div>
                      )}
                  </div>

                  <div style={{ width: "55%" }}>
                    {popupActive ? null : (
                      <GenAIFilterSelectModal
                        appliedFilters={appliedFilters}
                        filterCategory={filterCategory}
                        filters={filters}
                        handleApply={handleApply}
                        handleCloseFilterSelect={handleCloseFilterSelect}
                        handleSelectFilter={handleSelectFilter}
                        handleToggleFilter={handleToggleFilter}
                        isOpen={isOpen}
                        openFilters={openFilters}
                        selectedFilters={selectedFilters}
                        handleResetFilters={handleResetFilters}
                        customWidth={customWidth}
                        recentlyUsedFilters={recentlyUsedFilters}
                        fromRecentlyAddedUpdated={fromRecentlyAddedUpdated}
                        toRecentlyAddedUpdated={toRecentlyAddedUpdated}
                        gotoPageRecentlyAddedUpdated={
                          gotoPageRecentlyAddedUpdated
                        }
                        renderedFiltered={renderedFiltered}
                        isHomePageFilter={isHomePageFilter}
                      />
                    )}
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              {isHomePageFilter && <> {orderedFilters.map((filter, index) => {
                return (<React.Fragment >
                  {popupActive || selectedParent !== filter.label ? null : (
                    <GenAIFilterSelectModal
                      key={`gen-ai-filter-select-modal-${filter.label}-${index}`}
                      appliedFilters={appliedFilters}
                      filterCategory={filterCategory}
                      filters={filters}
                      handleApply={handleApply}
                      handleCloseFilterSelect={handleCloseFilterSelect}
                      handleSelectFilter={handleSelectFilter}
                      handleToggleFilter={handleToggleFilter}
                      isOpen={isOpen}
                      openFilters={openFilters}
                      selectedFilters={selectedFilters}
                      handleResetFilters={handleResetFilters}
                      customWidth={customWidth}
                      recentlyUsedFilters={recentlyUsedFilters}
                      fromRecentlyAddedUpdated={fromRecentlyAddedUpdated}
                      toRecentlyAddedUpdated={toRecentlyAddedUpdated}
                      gotoPageRecentlyAddedUpdated={
                        gotoPageRecentlyAddedUpdated
                      }
                      renderedFiltered={renderedFiltered}
                      isHomePageFilter={isHomePageFilter}
                    />
                  )}</React.Fragment>)
              })}</>}
              <div className={isHomePageFilter ? "gen-ai-filter-container scrollable contained" : "gen-ai-result-filter-container scrollable contained"} >
                {/* {popupActive ? null :
                <GenAIFilterSelectModal
                  appliedFilters={appliedFilters}
                  filterCategory={filterCategory}
                  filters={filters}
                  handleApply={handleApply}
                  handleCloseFilterSelect={handleCloseFilterSelect}
                  handleSelectFilter={handleSelectFilter}
                  handleToggleFilter={handleToggleFilter}
                  isOpen={isOpen}
                  openFilters={openFilters}
                  selectedFilters={selectedFilters}
                  handleResetFilters={handleResetFilters}
                  customWidth={customWidth}
                />
                } */}
                {(window.location.pathname === "/pubMedResults" /*||
                window.location.pathname === "/PubMedSearch"*/) &&
                  renderFilterHistogram()}
                {orderedFilters.map((filter) => {
                  if (
                    filter.label === "Recently Added_Updated" &&
                    (window.location.pathname === "/viewReadingList" ||
                      window.location.pathname === "/old_viewReadingList" ||
                      window.location.pathname === "/rawvalues" ||
                      window.location.pathname === "/viewPubMedReadingList" ||
                      window.location.pathname === "/GenAIViewReadingList" ||
                      window.location.pathname === "/genAIAnswering" ||
                      (window.location.pathname && 
                        window.location.pathname.startsWith("/genAISearch")))
                  ) {
                    return "";
                  }
                  return (
                    <div
                      className={
                        selectedParent === filter.label
                          ? "select-gen-ai-filter-item gen-ai-filter-item clickable"
                          : selectedParentFilterArr.includes(filter.label)
                            ? "gen-ai-filter-text-selected gen-ai-filter-item clickable"
                            : "gen-ai-filter-item clickable"
                      }
                      key={filter.key}
                      onClick={(e) => changeFilterCategory(e, filter.key)}
                      title={
                        filter.key === "Recently Added_Updated"
                          ? "Recently Added/Updated"
                          : filter.key
                      }
                    >
                      <div className="gen-ai-filter-text">
                        {filter.label === "Recently Added_Updated" ? (
                          <>{"Recently Added/Updated"}</>
                        ) : filter.label === "Document Subtypes" ? (
                          <>
                            {filter.label}
                            <br />
                            <span style={{ fontSize: "11px" }}>
                              (Submission-Related Documents Only)
                            </span>
                          </>
                        ) : (
                          <>{filter.label}</>
                        )}
                      </div>
                      {/* <FontAwesomeIcon 
                        className='gen-ai-filter-chevron'
                        icon="chevron-right"
                        fixedWidth
                        color='#979797' /> */}
                      {selectedParent === filter.label ? (
                        <div className="gen-ai-filter-expand-icon-wrapper-desktop">
                          <img src={gen_ai_prdtNavButton} alt="" />
                        </div>
                      ) : selectedParentFilterArr.includes(filter.label) ? (
                        <div className="gen-ai-filter-expand-icon-wrapper-desktop">
                          <img src={gen_ai_prdtNavButton} alt="" />
                        </div>
                      ) : (
                        <div className="gen-ai-filter-expand-icon-wrapper-desktop">
                          <img src={gen_ai_prdtNavButton} alt="" />
                        </div>
                      )}
                      {(isHomePageFilter || (popupActive || selectedParent !== filter.label)) ? null : (
                        <GenAIFilterSelectModal
                          appliedFilters={appliedFilters}
                          filterCategory={filterCategory}
                          filters={filters}
                          handleApply={handleApply}
                          handleCloseFilterSelect={handleCloseFilterSelect}
                          handleSelectFilter={handleSelectFilter}
                          handleToggleFilter={handleToggleFilter}
                          isOpen={isOpen}
                          openFilters={openFilters}
                          selectedFilters={selectedFilters}
                          handleResetFilters={handleResetFilters}
                          customWidth={customWidth}
                          recentlyUsedFilters={recentlyUsedFilters}
                          fromRecentlyAddedUpdated={fromRecentlyAddedUpdated}
                          toRecentlyAddedUpdated={toRecentlyAddedUpdated}
                          gotoPageRecentlyAddedUpdated={
                            gotoPageRecentlyAddedUpdated
                          }
                          renderedFiltered={renderedFiltered}
                          isHomePageFilter={isHomePageFilter}
                        />
                      )}
                    </div>
                  );
                })}
                <div className="gen-ai-filter-clear-button-wrapper">
                  {/* renderClearAllAppliedFilters() */}
                </div>
                {appliedFiltersForOnlyiMS &&
                  appliedFiltersForOnlyiMS.length > 0 &&
                  (window.location.pathname === "/pubMedResults" ||
                    window.location.pathname === "/PubMedSearch") && (
                    <div className="gen-ai-filter-only-ims-filters-wrapper">
                      <div className="ignored-ims-gen-ai-filter-wrapper">
                        <span class="ignored-header-text">
                          Missing Filters (iMS only)
                        </span>
                        <div className="gen-ai-filter-text">{renderOnlyiMSFilter()}</div>
                      </div>
                    </div>
                  )}
              </div>
            </>
          )}
        </>
      ) : (
        <div className="gen-ai-filter-container">
          {(window.location.pathname === "/pubMedResults" /*||
            window.location.pathname === "/PubMedSearch"*/) &&
            filterYearDocCount > 0 ? (
            renderFilterHistogram()
          ) : (
            <div style={{ padding: "10px 18px" }}>No refiners available.</div>
          )}
        </div>
      )}
    </>
  );
}

GenAIFilterMenu.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  filters: PropTypes.object.isRequired,
  handleChangeFilterCategory: PropTypes.func.isRequired,
  // handleClearFilters: PropTypes.func.isRequired,
  handleResetFilters: PropTypes.func,
};
